import React from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { DashboardPages } from "../../..";
import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import CustomMenu from "../../../../../../shared/components/CustomMenu/CustomMenu";
import TeamsSubMenuHeader from "../team-sub-menu-header/TeamsSubMenuHeader";
import { DashboardTeamsPages } from "../../containers/TeamRoutes";

const TeamsMenuItems = () => {
  const appUser = useAppUser();
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <>
      <Row>
        <Col xs={12}>
          <TeamsSubMenuHeader />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {appUser.userRole.isModerator ? (
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    history.push(DashboardPages.TEAMS);
                  },
                  text: "Teams",
                  isActive:
                    pathname.includes(DashboardPages.TEAMS) &&
                    !pathname.includes(DashboardTeamsPages.MEMBERS_TEAMS),
                },
                {
                  onClick: () => {
                    history.push(DashboardTeamsPages.MEMBERS_TEAMS);
                  },
                  text: "Members",
                  isActive: pathname.includes(
                    DashboardTeamsPages.MEMBERS_TEAMS
                  ),
                },
                // {
                //   onClick: () => {
                //     // history.push(DashboardTeamsPages.COMPANIES);
                //   },
                //   text: "Companies",
                //   isActive: pathname.includes(DashboardTeamsPages.COMPANIES),
                // },
              ]}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};

export default TeamsMenuItems;
